import { render, staticRenderFns } from "./Virtual.vue?vue&type=template&id=1fdd3d8c&scoped=true"
import script from "./Virtual.vue?vue&type=script&lang=js"
export * from "./Virtual.vue?vue&type=script&lang=js"
import style0 from "./Virtual.vue?vue&type=style&index=0&id=1fdd3d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd3d8c",
  null
  
)

export default component.exports